/**
 * Warstwa API: STRONA „PROCEDURY I BEZPIECZEŃSTWO” (polecenie właściciela 2026-10-01, projekt „Cykl życia na pasku”).
 *
 * Trasa backendu (`PolitykiController.Przeglady.cs`, `api/polityki`):
 *  • `GET obszary/macierz` — „Czego brakuje”: obszary (NIS2 / ISO / własne) × spółki objęte ustawą albo mające dokument.
 *    Komórkę liczy serwer (najlepszy stan, liczba dokumentów, a tytuły WYŁĄCZNIE dokumentów, które oglądający widzi —
 *    ta sama bramka co lista procedur); dla pustej komórki serwer podpowiada kod wzoru z biblioteki. Bramka: którykolwiek
 *    z pięciu kluczy modułu — jak dzisiejsze `obszary/stan`.
 */
export function attach(api) {
    return {
        getPolitykiMacierzObszarow: () => api.get("/polityki/obszary/macierz"),
    };
}
